import React, { useEffect, useState, useRef } from 'react';
import { Spin, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { type AppDispatch, type RootState } from '../../../redux/store';
// import {
//   getUnapprovedPaymentsAction,
//   updateUnsettledPaymentsAction,
// } from '../../Loan/store/loanActions';
import {
  getUnapprovedPledgeAction,
  updateApprovalPledgeAction,
} from '../../Pledge/store/pledgeActions';
import { type PledgeResponse } from '../../Pledge/store/pledgeTypes';

export default function PledgeApproval(): JSX.Element {
  const dispatch = useDispatch<AppDispatch>();

  const { unapprovedPledges }: any = useSelector<RootState>(
    (rootState) => rootState.pledge
  );

  const processingRef = useRef(false);
  const [isLoading, setIsLoading] = useState(false);

  const getUnapprovalList = async (): Promise<void> => {
    setIsLoading(true);

    await getUnapprovedPledgeAction(dispatch, {});
    processingRef.current = false;
    setIsLoading(false);
  };

  useEffect(() => {
    void getUnapprovalList();
  }, []);

  const handleUpdate = async (pledge: any, status: string) => {
    // if (processingRef.current) return;
    // processingRef.current = true;
    await updateApprovalPledgeAction(dispatch, {
      id: pledge._id ?? '',
      status,
    });
    void getUnapprovalList();
    processingRef.current = false;
  };

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      render: (_: unknown, record: PledgeResponse, index: number) => index + 1,
      width: 50,
    },
    {
      title: 'Branch',
      dataIndex: 'branch',
      key: 'branch',
      width: 150,
      render: (_: unknown, record: PledgeResponse, index: number) => (
        <p>{record.branch?.name}</p>
      ),
    },
    {
      title: 'Pledge Number',
      dataIndex: 'pledgeNumber',
      key: 'pledgeNumber',
      render: (_: unknown, record: PledgeResponse, index: number) => (
        <p>{record.pledgeNumber}</p>
      ),
    },
    {
      title: 'Min Rate per Gram',
      dataIndex: 'minGoldRate',
      key: 'minGoldRate',
      render: (_: unknown, record: PledgeResponse, index: number) => (
        <p>{record.minGoldRate}</p>
      ),
    },
    {
      title: 'Current Rate per Gram',
      dataIndex: 'currentRatePerGram',
      key: 'currentRatePerGram',
      render: (_: unknown, record: PledgeResponse, index: number) => {
        const totalNetWeight = record.jewels.reduce(
          (sum: number, item: any) => sum + item.netWeight,
          0
        );
        const ratePerGram =
          totalNetWeight > 0 ? record.principal / totalNetWeight : 0;

        return <p>{ratePerGram.toFixed(2)}</p>;
      },
    },
    {
      title: 'Principal',
      dataIndex: 'principal',
      key: 'principal',
      render: (_: unknown, record: PledgeResponse, index: number) => (
        <p>{record.principal}</p>
      ),
    },
    {
      title: 'Total Gross weight',
      dataIndex: 'totalGrossWt',
      key: 'totalGrossWt',
      render: (_: unknown, record: any, index: number) => (
        <p>
          {record.jewels
            .reduce((sum: number, item: any) => sum + item.grossWeight, 0)
            .toFixed(2)}
        </p>
      ),
    },
    {
      title: 'Total Net weight',
      dataIndex: 'totalNetWt',
      key: 'totalNetWt',
      render: (_: unknown, record: any, index: number) => (
        <p>
          {record.jewels
            .reduce((sum: number, item: any) => sum + item.netWeight, 0)
            .toFixed(2)}
        </p>
      ),
    },
    {
      title: 'Accept',
      dataIndex: 'actions',
      width: 100,
      render: (_: unknown, record: PledgeResponse, index: number) => (
        <button
          className="search__button"
          style={{
            background: !processingRef.current ? '#27ae60' : '#b2b2b2',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '8px 24px',
            fontWeight: 700,
            cursor: !processingRef.current ? 'pointer' : 'not-allowed',
            opacity: !processingRef.current ? 1 : 0.7,
          }}
          disabled={processingRef.current}
          onClick={() => {
            if (!processingRef.current) {
              processingRef.current = true;
              void handleUpdate(record, 'active');
            }
          }}
        >
          Accept
        </button>
      ),
    },
    {
      title: 'Reject',
      dataIndex: 'actions2',
      width: 100,
      render: (_: unknown, record: PledgeResponse, index: number) => (
        <button
          className="search__button"
          style={{
            background: !processingRef.current ? '#e74c3c' : '#b2b2b2',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '8px 24px',
            fontWeight: 700,
            cursor: !processingRef.current ? 'pointer' : 'not-allowed',
            opacity: !processingRef.current ? 1 : 0.7,
          }}
          disabled={processingRef.current}
          onClick={() => {
            if (!processingRef.current) {
              processingRef.current = true;
              void handleUpdate(record, 'rejected');
            }
          }}
        >
          Reject
        </button>
      ),
    },
  ];

  return (
    <div className="users__table__page">
      {!(unapprovedPledges.length > 0) && (
        <Spin spinning={isLoading} fullscreen />
      )}
      <div style={{ width: '100%' }}>
        <Table dataSource={unapprovedPledges} columns={columns} />
      </div>
    </div>
  );
}
